import AdminPhysiciansContainer from './physicians-container';

export default AdminPhysiciansContainer;